// global
import React from 'react';
// import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// components
import ControlButtons from 'app/components/commons/button/controlButtons/ControlButtons';
// redux
import { openUpdate } from 'app/redux/actions/modal/save-update-modal.action';
import { openChangeStatusModal } from 'app/redux/actions/modal/change-status-modal.action';
//stylesheet
import styles from './HealthProfessionalControlButtons.module.scss';

function HealthProfessionalControlButtons(props) {
  const onClickEdit = professional => () => {
    props.dispatch(openUpdate({ ...professional }));
  };

  const onChangeStatus = entity => () => {
    const statusName = entity.status;
    const status = statusName === 1 ? 1 : 0;
    props.dispatch(openChangeStatusModal({ ...entity, action: status }));
  };

  const { row } = props;

  const isChangeStatusActive = row.status === 1;
  const isEditButtonDisabled = !isChangeStatusActive;

  return (
    <div className={styles.healthProfessionalControlButtons}>
      <ControlButtons
        entity={row}
        onClickEdit={onClickEdit}
        onChangeStatus={onChangeStatus}
        isChangeStatusActive={isChangeStatusActive}
        disabledEdit={isEditButtonDisabled}
      />
    </div>
  );
}
HealthProfessionalControlButtons.propTypes = {
  auth: PropTypes.object,
  row: PropTypes.object,
  dispatch: PropTypes.func,
  allPatients: PropTypes.array
};

const mapStateToProps = state => ({
  auth: state.auth,
  patient: state.patient,
  data: state.data
});
export default connect(mapStateToProps)(HealthProfessionalControlButtons);
